<template lang="">
    <div :class="isPublicRoute() == true ? 'theme-card adjustment':'theme-card'">
        <!-- <PageHeader :class="isPublicRoute() == true ? 'adjustment':''" title="Privacy Policy"/> -->
        <TermsOfServiceContent/>
    </div>
</template>
<script>
  import PageHeader from '@/components/Utility/PageHeader.vue';
  import TermsOfServiceContent from '@/components/TermsOfServiceContent.vue';
  export default{
    components:{
        PageHeader, TermsOfServiceContent
    },
     mounted(){
       window.scrollTo({top: 0,behavior: 'smooth'});
    },
    methods:{
        isPublicRoute(){
            return this.$route.name == 'terms-of-service' ? true : false
        }
    }
}
</script>
<style scoped>
   .adjustment{
        margin-top: 3rem!important;
   }

   .theme-card{
    border-radius:20px;
    padding:2.2rem;
    background: url('../assets/images/blurs.png') fixed no-repeat center/90%, var(--intro-background);
   }

   @media(max-width: 768px){
    .theme-card{
        padding:1.2rem;
    }
   }
</style>